import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../../../hooks/useKeyPress';
import BodyContentView from '../../../views/bodyContentView';
import {useMenu} from '../../../../hooks/useMenu';
import CommandsContext from '../../../../context/commandsContext';

function MenuAvailable({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, setSelected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    setSelected(selected.children[0]);
    onExit();
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  return (
    <BodyContentView
      title="-- WARNING --"
      left="No"
      right="Yes"
      caption="The local display 'Menu' option from the Process Variable screen will not be accessible if 'Disabled' is selected. Continue?"
    />
  );
}

export default MenuAvailable;
